
import { fetchAuthSession } from 'aws-amplify/auth';
import { BedrockAgentRuntimeClient, InvokeAgentCommand } from "@aws-sdk/client-bedrock-agent-runtime"

const GeneratePrompt = async (story, style) => {
    const session = await fetchAuthSession()
    // console.log(session)

    const bedrockClient = new BedrockAgentRuntimeClient({
        region: 'us-east-1',
        credentials: session.credentials
    });

    let prompt = "You are an expert illustrator. You are making an image for a page of a children's book in the style of " + style + ". Develop a prompt that would be perfect for an image generation model based on the following context.";

    if (story.description !== "") {
        prompt += " Here are some details about the book, " + story.description + " ";
    }

    if (story.setting !== "") {
        prompt += "This is the general setting " + story.setting + " ";
    }

    prompt += "Make sure the prompt is concise and provides an overview description of the scene on the page for an image generation model and will pass prompt check AUP or AWS Responsible AI Policy."
    // console.log(prompt);

    const id = story.id ?? crypto.randomUUID();

    const params = {
        sessionId: id,
        agentId: "6SB5IAJLML", //"XUJQQWIVLQ", // TODO: make .env
        agentAliasId: "CWJK9MYJFW", // "2MX1RREMNI",
        inputText: prompt
    }
    try {
        const command = new InvokeAgentCommand(params);
        const response = await bedrockClient.send(command);
        // console.log('Response from Bedrock agent:', response);
        let completion = ""

        /*     for await (const chunk of stream) {
                console.log(chunk)
            } */

        let decoder = new TextDecoder("utf-8")
        for await (const chunk of response.completion) {
            // console.log("chunk:", chunk)
            const text = decoder.decode(chunk.chunk.bytes)
            completion += text
            // console.log(text)
        }

        return completion
    } catch (error) {
        console.error('Error calling Bedrock agent:', error);
    }
};

export default GeneratePrompt;